module.exports = __webpack_public_path__ + "img/커세어 (2).7c9e9089.png";